import {useEffect, useState} from 'react';
import {BREAKPOINTS} from "../Constants.js";

const useIsMobile = () => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const updateSize = () => {
            setIsMobile(window.innerWidth < BREAKPOINTS.mobileBreakpoint);
        };

        updateSize();

        window.addEventListener('resize', updateSize);

        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return isMobile;
};

export default useIsMobile;
